export enum HeaderMode {
    Home = 1,
    JobDetails,
    Bom,
    ProductionOrderImages,
    SimilarProductionOrdersImages,
    ManageImages,
    ReportIssue,
    None
  }